/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { AccountMenu } from '@/components/menus/AccountMenu';
import { MenuProps } from '@/components/menus/builder';
import { MainMenu } from '@/components/menus/MainMenu';
import { Container } from '@/primitives/Container';

export type LeftMenuProps = MenuProps & {
  children?: React.ReactNode;
};

export function LeftMenu({ tenantID, currentUser, currentPath, children }: LeftMenuProps) {
  return (
    <Container gap="none" justify="space-between" full>
      <Container.Expand>
        {children}
        <MainMenu tenantID={tenantID} currentUser={currentUser!} currentPath={currentPath} />
      </Container.Expand>
      <Container.Fixed>
        <AccountMenu tenantID={tenantID} currentUser={currentUser!} currentPath={currentPath} />
      </Container.Fixed>
    </Container>
  );
}
